import { Box, Select } from '@byecode/ui'
import type { FlowNode } from '@lighthouse/shared'
import { getUpstreamNodeOption, ListItem4ByecodeUi, OUTPUT_MULTIPLE_DATA_NODES } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList } from '@/hooks/useDataSource'

import * as SC from '../../styles'

const Description = SC.Tip

interface SelectMultipleRecordProps {
    allParentNodes: FlowNode[]
    value?: string
    onChange?: (value: string) => void
    // 描述
    description?: string
}

export const SelectMultipleRecord: React.FC<SelectMultipleRecordProps> = ({ allParentNodes, value, onChange, description }) => {
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const dataSourceList = useDataSourceList(appId, envId)
    const nodeOptions = useMemo(() => {
        return getUpstreamNodeOption({
            allParentNodes,
            dataSourceList,
            filter: node => OUTPUT_MULTIPLE_DATA_NODES.has(node.data.nodeType),
            isIncludeAggregateDataSource: true
        })
    }, [allParentNodes, dataSourceList])

    return (
        <Box>
            <ListItem4ByecodeUi>
                <SC.FormItemLabelWrapper>
                    <SC.FormItemLabel>选择上游节点</SC.FormItemLabel>
                </SC.FormItemLabelWrapper>
                <SC.FormItemContent>
                    <Select
                        value={value}
                        options={nodeOptions}
                        notFound="找不到节点"
                        onChange={val => {
                            if (value === val) {
                                return
                            }
                            onChange?.(val)
                        }}
                    />
                </SC.FormItemContent>
            </ListItem4ByecodeUi>
            {description && (
                <Box px={8} py={0}>
                    <Description>{description}</Description>
                </Box>
            )}
        </Box>
    )
}
